<div class="d-flex justify-content-center align-items-center" [ngClass]="{'spinner-div' : mainFeed === true}">
    <div class="spinner-border spinner text-danger" role="status">
    </div>
</div>